<template>
  <div class="text-block block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-question-icon white--text text-lg-2" />
            </div>

            <h4>
              Suggestion 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <div class="block-card-body" v-if="validData">
          <form-validation 
            v-model = "errorsCount" 
            :append = "buttonsModel.errorsCount" >
            <label>Text</label>
            <vTextareaAutocomplete 
              v-model="data.text" 
              :type="'textarea'"
              :validation-rules="autocompleteSuggestedValidationRules" 
              :counter = "1000"/>
          </form-validation>                                        
          <buttons-list 
            :buttons="data.buttons" 
            :blocks-list="blocksList" 
            v-model = "buttonsModel" />
        </div>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import buttonsList from './common-inner-blocks/button-list-blocks'
import FormValidation from '../FormValidation'
export default {
  name: 'card-suggested',
  components: {
    buttonsList,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      buttonsModel: { errorsCount: 0 },
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      autocompleteSuggestedValidationRules: [v => !!v || 'Text is Required']
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
    if (!this.data.buttons) {
      this.data.buttons = []
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>
